import { render, staticRenderFns } from "./debug3.vue?vue&type=template&id=840d7af8&scoped=true"
import script from "./debug3.vue?vue&type=script&lang=js"
export * from "./debug3.vue?vue&type=script&lang=js"
import style0 from "./debug3.vue?vue&type=style&index=0&id=840d7af8&prod&lang=scss&scoped=true"
import style1 from "./debug3.vue?vue&type=style&index=1&id=840d7af8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840d7af8",
  null
  
)

export default component.exports